import { Tab } from '@alifd/next';
import { Result } from 'antd';
import React, { useEffect, useState } from 'react';

import client from '@/lib/feathers';

import PreservationButton from '../PreservationButton';
import Slider from '../Slider';
import styles from './index.module.scss';

function PreservationFrontDeskList() {
  const homeSecurity = client.service('homeSecurity');
  const [arrDiv, setArrDiv] = useState([]);
  const [groupDataArr, setGroupDataArr] = useState([]);
  const [selectTabName, setSelectTabName] = useState('');
  const [rangeValue, setRangeValue] = useState(0);
  const [usersHouseholdNumbers, setUsersHouseholdNumbers] = useState('');
  const [value, setValue] = useState('');
  const [showMailOpen, setShowMailOpen] = useState(false);

  const detachedContentStyle = {
    border: '1px solid #DCDEE3',
    padding: '20px',
  };
  // console.log("groupDataArr",groupDataArr)

  const onChangeSlider = (e) => {
    setRangeValue(parseInt(e.target.value, 0));
  };

  function updateMultiState(arr) {
    // arr:[socket更新的data] || [find All的data]
    console.log(
      '==原baDeviceArr:',
      arr.map((x) => `${x.text}:${x.value}`).join(',')
    );

    setArrDiv((prevState) => {
      let finalArr = [];
      if (prevState.length === 0 && arr.length > 0) {
        // [find All的data]
        finalArr = arr;
      } else {
        // [socket更新的data]
        prevState = [...prevState].map((i) => i.props.item);
        const tarNames = [...arr].map((i) => i.name || false);
        finalArr = [...prevState].map((i) => {
          if (i.name && tarNames.includes(i.name)) {
            const tarChildNb = tarNames.indexOf(i.name);
            return {
              ...i,
              ...arr[tarChildNb],
            };
          }
          return i;
        });
      }

      return finalArr.map((x) => {
        //  console.log(x.value,typeof x.value)
        if (isNaN(parseInt(x.value)))
          return (
            <PreservationButton
              key={x._id}
              item={x}
              setValue={setValue}
              value={value}
              showMailOpen={showMailOpen}
              setShowMailOpen={setShowMailOpen}
            />
          );
        // parseInt("開啟")=NaN
        else {
          return (
            <Slider
              key={x._id}
              item={x}
              min={0}
              max={100}
              step={1}
              defaultLength={x.value}
              value={x.value}
              onChangeValue={onChangeSlider}
              linearGradientColor="#4aa1f3"
              rangeBackgroundColor="#d7dcdf"
              sliderThumbColor="#4aa1f3"
            />
          );
        }
      });
    });
  }
  function renderNewArr() {
    // console.log(arrDiv);
    if (selectTabName === '') return arrDiv;
    return [...arrDiv].filter((x) => {
      if (!x.props.item.group) return false; // 回傳過濾沒有Group key
      return x.props.item.group === selectTabName;
    });
  }

  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        console.log('==relogin ok', data.user);
        setUsersHouseholdNumbers(
          !data.user.hasOwnProperty('householdNumbers') ||
            data.user.householdNumbers.length === 0
            ? false
            : data.user.householdNumbers
        );
        homeSecurity
          .find({
            query: {
              // securityIp: { $exists: true },
              householdNumber: { $in: data.user.householdNumbers },
            },
          })
          .then((result) => {
            console.log(result);
            // console.log("result", result.data)
            // call getallstate?
            setValue(result.data[0].value);
            setGroupDataArr((groupDataArr) => [
              ...new Set(groupDataArr.concat(result.data.map((x) => x.group))),
            ]);
            updateMultiState(result.data); // 暫時處理
          })
          .catch((error) => {
            console.log('==原baDeviceArr:', error);
          });
      })
      .catch((err) => {
        console.log('==relogin fail', err);
        // history.push('/user/login');
      });

    // client.reAuthenticate().then((data) => {
    //   console.log('==relogin ok', data.user.email);
    // }).catch(err => {
    //   console.log('==relogin fail');
    //   // history.push('/user/login');
    // })
  }, [value]);

  useEffect(() => {
    client.service('homeSecurity').on('securityStatus', (data) => {
      // console.log(JSON.parse(data), '====securityStatus');
      setValue(JSON.parse(data).value);
      setShowMailOpen(false);
    });
    // client.service.on('securityStatus', (arr) => {
    //   console.log('==socket', arr);
    //   // updateMultiState(arr);
    // });
  }, []);
  //   useEffect(() => {
  //     setArrDiv(arrDev.map(x=><PreservationButton item={x}></PreservationButton>))
  //   },[arrDev]);

  return (
    <>
      {/* <Tab
      className={styles.tab}
      // lazyLoad={false}
      shape="pure"
      contentStyle={detachedContentStyle}
      onChange={(key) => {
        // console.log(groupDataArr[key])

        if (groupDataArr[key] === '全部') {
          setSelectTabName('')
        } else {
          setSelectTabName(groupDataArr[key])
        }

      }}>
  
        {
          groupDataArr.map((item, index) => <Tab.Item title={item} key={index}>
          <div className={styles.BAList}>{renderNewArr()}</div>
        
          </Tab.Item>)
          
        }

    </Tab> */}
      <div className={styles.mobilePreservationContainer}>
        <div className={styles.mobilePreservationBackground} />
        <div className={styles.mobileHouseholdTitle}>戶號</div>
        <div className={styles.mobileHousehold}>
          {usersHouseholdNumbers ? usersHouseholdNumbers[0] : '尚未開通戶號'}
        </div>
        <div className={styles.BAList}>
          {groupDataArr.length > 0 ? (
            renderNewArr()
          ) : (
            <Result
              status="warning"
              title="尚未安裝保全系統，請與管理中心聯絡"
            />
          )}
        </div>
      </div>
    </>
  );
}

export default PreservationFrontDeskList;
